import { HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { filter } from 'rxjs';

import { NavigationEnd, Router } from '@angular/router';
import { MpsApiService } from '../../mps/services/mps-api.service';
import { SKIP_LOADER } from '../interceptors/skip-loader.token';
import { mpsEndpoints } from '../mps-endpoints';

@Injectable({ providedIn: 'root' })
export class LoggingService {
  private _apiService = inject(MpsApiService);
  private _router = inject(Router);

  initNavigationLogging() {
    this._router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.abyssLogPageVisit(event.urlAfterRedirects);
    });
  }

  private abyssLogPageVisit(urlVisited: string): void {
    this._apiService
      .post(mpsEndpoints.abyssLogPageVisit, { url: urlVisited }, { context: new HttpContext().set(SKIP_LOADER, true) })
      .subscribe();
  }
}
